/**
 * @link https://stackoverflow.com/a/46455994/1847705
 */
import { Pipe, PipeTransform } from '@angular/core';
import { MONTHS_ARRAY } from './config';

@Pipe( { name: 'month' } )
export class MonthPipe implements PipeTransform {
    
    transform( pMonthId: number ): string {
        const months = MONTHS_ARRAY;
        return pMonthId == null ? null : months[ pMonthId - 1 ];
    }
}
